import { Reveal } from "@/components/bits";

export default function Manifiesto() {
  return (
    <section id="manifiesto" data-testid="manifiesto-section" className="bg-ink py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6">
        <Reveal>
          <p className="flex items-center justify-center gap-4 text-[11px] font-medium uppercase tracking-[0.3em] text-gold">
            <span className="h-px w-10 bg-gold/50" />
            Manifiesto
            <span className="h-px w-10 bg-gold/50" />
          </p>
          <p className="mt-10 font-serif text-3xl italic leading-snug text-cream sm:text-4xl lg:text-[2.75rem]">
            Conocé lo mejor de nuestra literatura nacional{" "}
            <span className="text-gold">lejos del culto a los escritores varones.</span>
          </p>
          <p className="mt-12 font-serif text-2xl italic leading-snug text-gold sm:text-3xl lg:text-4xl">
            ¿Cuántas autoras tenés en tu biblioteca?
            <br />
            ¿Y en tu <span className="text-gold">imaginario?</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
